<template>
<section id="hero" :class="(hero_show_vid ? 'show_vid': '')" v-if="loaded">
      <div style="width:100%; height:100%; display:block;">
        <div class="centered">
          <div id="hero_pages" v-if="!is_mobile()">
            <a v-for="item in promotedComp" @click="heroItem = item;curItem=item.indexSlide" :class="{'active':(item.id == heroItem.id)}"  :key="item.id"></a>
          </div>
         
        </div>

        <div id="hero_items">
          <!-- <transition name="fade"> -->
          <div :class="'hero_item_wrap ' + (heroItem.restricted ? 'restricted' : '')" :key="heroItem.id"  @mouseover="hover = true" @mouseleave="hover = false">
            
            <!-- <div class="pic" :style="'background-image:url(' + heroItem.pic_hero_parsed + ')'"></div> -->
            <div class="pic"></div>
                <label v-if="heroItem.sticker > 0" class="lbl_sticker" ><span v-text="$store.state.stickers[heroItem.sticker].name"></span></label>

            <a @click="muted = !muted"  :class="'mute_btn '+ (muted ? 'mute' : 'unmute') "></a>

            <router-link v-if="heroItem.restricted !== true" :to="heroItem.url" class="btn">הפעל
            <div class="promo_video" id="videopromo_hero" v-if="!is_mobile()">
              <!-- <video ref="videopromo_hero_vid" muted>
              <source :src="heroItem.video_promo" type="video/mp4">
              </video> -->

              <video-bg ref="videobg_elem" :muted="muted" :sources="[heroItem.video_promo]" :img="heroItem.bgImg"></video-bg>

            </div>
            </router-link>

            <div class="centered" style="pointer-events:none;">
            <div class="details" style="pointer-events:all;position:relative">
              <label v-if="heroItem.restricted === true" class="lbl_restricted">מוגבל</label>
              <router-link :to="(heroItem.restricted === true ? '' : heroItem.url)">
              <h1>{{ heroItem.title }}</h1>
              <div class="props">
                <span v-text="(heroItem.type == 'series' ? 'סדרה' : 'סרט')"></span>
                <span v-if="heroItem.main_category" v-text="heroItem.main_category.name"></span>
                <span v-if="heroItem.seasons != undefined && heroItem.seasons.length > 1">{{ heroItem.seasons.length }} עונות</span>
                <span>{{heroItem.year}}</span>
            </div>
              <h3 class="animate-fast">{{ heroItem.description }}</h3>
              </router-link>
              <router-link :to="heroItem.url" class="more_info" >למידע נוסף <i class="fas fa-chevron-left"></i></router-link>

              <router-link :to="heroItem.url" class="btn" v-if="heroItem.restricted != true"><i class="far fa-play-circle"></i>הפעל</router-link>
              <a class="btn" @click="add_to_fav(heroItem.id)" v-if="heroItem.restricted != true"><i class="far fa-star"></i>הוספה למועדפים</a>
           <div id="hero_pages" v-if="is_mobile()">
            <a v-for="item in promoted" @click="heroItem = item;curItem=item.indexSlide" :class="{'active':(item.id == heroItem.id)}"  :key="item.id"></a>
          </div>
            </div>
            </div>
          </div>
          <!-- </transition> -->
        </div>
      </div>
    
    </section>

</template>

<script>


export default {
  props: ["promoted"],

  data() {
    return {
      heroItem: {},
      hero_show_vid: true,
      muted: true,
      loaded: false, 
      timer: null,
      curItem: 0,
      videoElem: null,
      hover: false,
    };
  },
  computed:{
    promotedComp(){
      let ret = []
      for(let i in this.promoted)
      {

        ret[i] =  this.promoted[i];
        ret[i].indexSlide = i;
        if(!ret[i].video_promo){
          ret[i].bgImg = ret[i].pic_hero_parsed;
        }
        ret[i].url =  (ret[i].restricted === true ? '' : 
        (ret[i].type == 'live' ? '/livePage/' : '/item/')
        + 
      ret[i].id
      )

         
      }
      return ret
    }
    
  },
  methods: {

    get_cat_items(cat)
    {
      return cat.items;
    },
    
    hero_pages_change(num){
    
      for (var i in this.promoted)
      {
        this.promoted[i].is_active = (i == num);
      }
      
    },
    startSlide() {
        this.timer = setInterval(this.slideItem, 6000);
    },
    slideItem() {
      if(this.hover===false){
      if(this.promoted[this.curItem]){ 
            this.heroItem = this.promoted[this.curItem];
            this.curItem ++;
      //       if(this.promoted[this.curItem].video_promo){
      //           this.$refs["videopromo_hero_vid"][this.curItem].play();
      //        }
      }else{
        this.curItem = 0;
      } 
      }
    },

  },
  updated: function () {
      window.dispatchEvent(new Event('resize'));
  },
  mounted() {

    this.startSlide();
    
     var self = this;

    this.heroItem = this.promoted[0];
    this.loaded = true;

    setTimeout(() => {
      // if(self.$refs["videopromo_hero_vid"]){
      // console.log(self.$refs["videopromo_hero_vid"])
      // self.$refs["videopromo_hero_vid"][0].play();
      // }
      self.hero_show_vid = true;
      
    }, 1000);
      
  },

}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>